// Our modules / classes
import MySearch from "./modules/MySearch"

// Instantiate a new object using our modules/classes
const mySearch = new MySearch()